import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade } from "react-bootstrap";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
    Collapse, FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import moment from "moment";
import toast from "react-hot-toast";
import { FiLink } from "react-icons/fi";

import CustomTableV2 from '../../common/CustomTableV2';
import CustomButton from "../../common/CustomButton";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";
import CustomCard from "../../common/CustomCard";
import PatientInfo from "./components/PatientInfo";
import EmailPrompt from "./components/EmailPrompt";
import EmailContent from "./components/EmailContent";
import EmailContentFilterPrompt from "./components/EmailContentFilterPrompt";
import CustomDropDownToggle from "../../common/CustomDropDownToggle";
import EmailSentLogs from "./components/EmailSentLogs";
import GeneratedEmailLogs from "./components/GeneratedEmailLogs";

import {
    GetBRGDSDischargedPatients, GetPatientsGeneratedEmails, GetPrompt, GenerateEmail, FilterEmailContent,
} from "../../redux/brg/actions";
import { GetAllIndiPrograms } from "../../redux/program/actions";
import { GetEmailTemplates } from "../../redux/emailTemplate/actions";
import { getAge } from '../../utils/date';
import usePrompt from "../../hooks/usePrompt";
import useEmail from "../../hooks/useEmail";

import "./style.css";
import CustomSelect from "../../common/CustomSelect";
import FollowUpEmail from "./components/FollowUpEmail";
import EmailContentV2 from "./components/EmailContentV2";

function BRGPatientPrompt(props) {
    const { arrangeEmailPrompt, arrangeFilteredEmailPrompt } = usePrompt();
    const { arrangeEmailContent } = useEmail();


    const [allPrograms, setAllPrograms] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [emailTemplate, setEmailTemplate] = useState(null);
    const [therapyInfoDisplay, setTherapyInfoDisplay] = useState({});
    const [therapyInfoDisplayAll, setTherapyInfoDisplayAll] = useState(false);

    const programs = props?.Program?.indiPrograms?.data || [];
    useEffect(async () => {
        props.GetAllIndiPrograms();
        await props.GetEmailTemplates(1, 100, { owner: null }, null);

        props.GetPrompt("email-filter-prompt", "emailFilterPrompt");
        props.GetPrompt("generate-email-prompt", "emailPrompt");

    }, []);

    useEffect(() => {

        let upd = props?.Brg?.brgDischargedPatients?.list?.filter(p => p?.id == selectedPatient?.id);
        setSelectedPatient(upd[0]);

    }, [props?.Brg?.brgDischargedPatients?.list]);

    useEffect(() => {
        let temp = {};
        for (let x = 0; x < props?.Program?.all?.list?.length; x++) {
            temp["p-" + props?.Program?.all?.list[x]?.id] = props?.Program?.all?.list[x];
        }
        setAllPrograms(temp);
    }, [props?.Program?.all?.list]);


    const getSuggestedPrograms = (programIDs, limit = 3) => {
        if (!programIDs) return [];

        programIDs = JSON.parse(programIDs);

        let id = "";
        let suggestedPrograms = [];

        for (let x = 0; x < (programIDs?.length <= limit ? programIDs?.length : limit); x++) {
            id = (programIDs[x] + "").split("-");
            suggestedPrograms.push({
                ...allPrograms["p-" + id[0]],
                level: id?.[1] ? ["", "BEGINNER", "MODERATE", "ADVANCED"][id?.[1] * 1] : null
            });
        }


        return suggestedPrograms;
    }

    return (
        <>
            <Fade in>
                <div className="main-container" style={{ overflow: true ? "inherit" : "hidden" }} id="bfg-patient-prompt">

                    <CustomTableV2
                        title="BRG Discharged Patients"
                        description=""
                        store={props?.Brg?.brgDischargedPatients}
                        table={{
                            headers: [

                                { title: "#" },
                                { title: "Name" },
                                { title: "Age" },
                                { title: "Last Appointment" },
                                { title: "Discharge Email" },
                                { title: "Email Reminder" },
                                { title: "Link" },
                                { title: "" },
                            ],
                            body: (patient, i) => {
                                const sp = getSuggestedPrograms(patient?.suggested_programs);
                                const key = patient?.patient_id + "-" + i;
                                const displayTI = therapyInfoDisplayAll || (therapyInfoDisplay?.[key] || false)

                                const d = moment(new Date()).format("YYYY-MM-DD");

                                const emailReminder = patient?.emailSentLogs?.filter(esl => esl?.email_type?.includes("reminder"));

                                const url = (patient?.generatedEmails?.[patient?.generatedEmails?.length - 1]?.id && patient?.emailSentLogs?.[patient?.emailSentLogs?.length - 1]
                                    ?.event_id) ? `${"https://indimoves.com/brg/"}?type=brgpatient&id=${patient?.generatedEmails?.[patient?.generatedEmails?.length - 1]?.id}&event_id=${patient?.emailSentLogs?.[patient?.emailSentLogs?.length - 1]?.event_id}&env=${process.env.REACT_APP_ENVIRONMENT}`
                                    : null;

                                const patientName = patient?.first_name + " " + patient?.last_name;

                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{(patientName).toUpperCase()}</h5></td>
                                        <td><h5>{getAge(patient?.dob)}</h5></td>
                                        <td><h5>{moment(patient?.date_of_last_appointment).format("lll")?.toUpperCase()}</h5></td>
                                        <td><h5>{patient?.emailSentLogs?.length > 0 ? "YES" : "NO"}</h5></td>
                                        <td><h5>{emailReminder?.length > 0 ? "YES" : "NO"}</h5></td>
                                        <td>
                                            {
                                                url ? <FiLink title="Copy Invitation Link" className="copy-link" onClick={async () => {
                                                    await navigator.clipboard.writeText(url);
                                                    toast.success(`Invitation link copied for ${patientName}!`);
                                                }} /> : "-"
                                            }
                                        </td>
                                        <td><ArrowForwardIosIcon id="view-arrow" onClick={async () => {
                                            setSelectedPatient(patient);

                                            const ge = patient.generatedEmails.filter(g => g.filtered == 0)
                                            const fge = patient.generatedEmails.filter(g => g.filtered == 1)

                                            if (ge?.length == 0 && fge?.length == 0) {
                                                const toastID = toast.loading(`Generating Email for ${(patientName).toUpperCase()}...`);

                                                const emailProcessedPrompt = await arrangeEmailPrompt({
                                                    ...patient,
                                                    sp: getSuggestedPrograms(patient?.suggested_programs)
                                                }, props.Brg.emailPrompt?.text,);
                                                const resGE = await props.GenerateEmail(emailProcessedPrompt, patient?.id);

                                                const geContent = await arrangeEmailContent(JSON.parse(resGE?.data?.email_content));

                                                const filteredEmailProcessedPrompt = await arrangeFilteredEmailPrompt(geContent, props.Brg.emailFilterPrompt?.text);
                                                const resFE = await props.FilterEmailContent(filteredEmailProcessedPrompt, patient?.id, resGE?.data);

                                                toast.dismiss(toastID);
                                            }
                                            setShowModal(true);
                                        }} /></td>

                                    </tr>
                                )
                            }
                        }}
                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetBRGDSDischargedPatients(page, count, filter, sort);
                            },
                            filter: {
                                name: "Filter",
                                key: "brg-patient-list-filter",
                                options: [
                                    { value: "all", label: "All" },
                                    { value: "sent", label: "Sent" },
                                    { value: "notSent", label: "Not Sent" },
                                ],
                                onChange: (e) => {
                                }
                            },
                        }}
                    />

                </div>
            </Fade>
            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"PATIENT DISCHARGE"}>
                <div id="csm-brg-pp-content" className="row">
                    <div className="col-md-12">
                        <CustomCard className="brg-pd-main-card">
                            <div className="row" id="patient-info-and-prompt-corner">
                                <div className="col-md-4">
                                    <PatientInfo patient={selectedPatient} getSuggestedPrograms={getSuggestedPrograms} />
                                </div>

                                <div className="col-md-4">
                                    <EmailPrompt patient={selectedPatient} getSuggestedPrograms={getSuggestedPrograms} />
                                </div>

                                <div className="col-md-4">
                                    <EmailContentFilterPrompt patient={selectedPatient} email={selectedEmail} />
                                </div>
                            </div>

                            <div className="row" id="email-content-corner">
                                <div className="col-md-12">
                                    <EmailContentV2 patient={selectedPatient} setSelectedEmail={setSelectedEmail} emailTemplate={emailTemplate} suggestedPrograms={getSuggestedPrograms(selectedPatient?.suggested_programs)} />
                                </div>
                            </div>


                            <div className="row" id="email-logs-corner">
                                <div className="col-md-12">
                                    <EmailSentLogs patient={selectedPatient} id="patient-email-sent-logs" />
                                </div>
                            </div>
                        </CustomCard>
                    </div>
                </div>

            </CustomSliderModalV2 >
        </>

    );
}

const mapStateToProps = (state) => ({
    Brg: state.Brg,
    Program: state.Program
})

export default connect(mapStateToProps, {
    GetBRGDSDischargedPatients,
    GetAllIndiPrograms,
    GetPatientsGeneratedEmails,
    GetEmailTemplates,
    GetPrompt,
    GenerateEmail,
    FilterEmailContent,
})(BRGPatientPrompt);
